// extracted by mini-css-extract-plugin
export default {"pure-material-switch":"styles_pure-material-switch__GBU4o"};